import { render, staticRenderFns } from "./popupAnotacaoHandler.vue?vue&type=template&id=7746a44c&scoped=true"
import script from "./popupAnotacaoHandler.vue?vue&type=script&lang=js"
export * from "./popupAnotacaoHandler.vue?vue&type=script&lang=js"
import style0 from "./popupAnotacaoHandler.vue?vue&type=style&index=0&id=7746a44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7746a44c",
  null
  
)

export default component.exports